import { X } from "lucide-react";
import * as LucideIcons from "lucide-react";
import { useState } from "react";

interface Banners03Props {
    text: string;
    buttonText?: string;
    link?: string;
    icon?: string;
    direction?: "auto" | "rtl" | "ltr";
    onClose?: () => void;
}

export function Banners03({
    text,
    buttonText = "اشترِ الآن",
    link = "#",
    icon = "ArrowLeft",
    direction = "auto",
    onClose
}: Banners03Props) {
    const [isVisible, setIsVisible] = useState(true);

    if (!isVisible) return null;

    // Resolve Icon - simple dynamic lookup
    const IconComponent = (LucideIcons as any)[icon] || LucideIcons.ArrowLeft;

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) onClose();
    };

    return (
        <div
            className="flex w-full items-center justify-between gap-x-6 bg-secondary px-8 py-2.5 sm:px-10 lg:px-12"
            dir={direction === 'auto' ? undefined : direction}
        >
            <div className="flex flex-1 items-center gap-x-4">
                <p className="text-sm font-medium text-secondary-foreground">
                    {text}
                </p>
            </div>

            <div className="flex items-center gap-x-4">
                <a
                    href={link}
                    className="flex-none rounded-full bg-primary px-3.5 py-1 text-sm font-semibold text-primary-foreground shadow-sm hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary flex items-center gap-2"
                >
                    {buttonText} <IconComponent className="h-4 w-4" aria-hidden="true" />
                </a>

                <button
                    type="button"
                    onClick={handleClose}
                    className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
                >
                    <span className="sr-only">Dismiss</span>
                    <X className="h-5 w-5 text-secondary-foreground" aria-hidden="true" />
                </button>
            </div>
        </div>
    );
}
